import * as React from 'react';
import { fetchApi, makeResetCache, notifyError, notifyResponse, RecordPicker } from 'gossamer-front-end';
import {
  AdminInstitutionGroupEventAddRequest,
  Event,
  InstitutionGroup,
  InstitutionGroupEvent,
  InstitutionGroupEventView,
} from 'cb-model';
import { Button, InputGroup } from 'react-bootstrap';
import { FieldType, getFilter } from 'gossamer-unified';
import { useDispatch } from 'react-redux';

export interface AddGroupToEventButtonProps {
  eventId: number;
  institutionId: number;
}

export const AddGroupToEventButton: React.FC<AddGroupToEventButtonProps> = (props) => {
  const [groupId, setGroupId] = React.useState<string | null>(null);
  const dispatch = useDispatch();
  const resetCache = makeResetCache(dispatch);
  const isProcessing = React.useRef(false);

  const handleClick = async () => {
    if (isProcessing.current || !groupId) {
      return;
    }
    try {
      isProcessing.current = true;
      const resp = await fetchApi('POST', `/main/institution-group-event-add`, {
        eventId: props.eventId,
        institutionGroupId: parseInt(groupId),
      } as AdminInstitutionGroupEventAddRequest);
      resetCache(Event.id);
      resetCache(InstitutionGroupEvent.id);
      resetCache(InstitutionGroupEventView.id);
      setGroupId(null);
      notifyResponse(resp);
    } catch (e) {
      notifyError(e, 'An error occurred while adding the event to the group');
    }
    isProcessing.current = false;
  };
  return (
    <InputGroup>
      <InputGroup.Text>Add this Event to a Group</InputGroup.Text>
      <RecordPicker
        editable={true}
        onItemSelected={setGroupId}
        value={groupId}
        field={{
          seq: 0,
          type: FieldType.Reference,
          label: 'Group',
          refEntity: InstitutionGroup,
        }}
        queryOptions={{
          where: {
            and: [getFilter('title', 'ct', ''), getFilter('institution_id', 'eq', props.institutionId, 'hidden')],
          },
          order: [['title', 'ASC']],
        }}
      />
      <Button size="sm" variant="primary" disabled={!groupId} onClick={handleClick}>
        Add
      </Button>
    </InputGroup>
  );
};
